import type { WaveEventConfig } from './WaveEventConfig';

export const BOARLING_WAVE_CONFIG: WaveEventConfig = {
  id: 'boarling_wave',
  displayName: 'Волна Кабанчиков',
  bossType: 'wave_event',

  enemyId: 'boarling',
  enemyCount: 18,
  spawnIntervalMs: 70,

  introText: 'ВОЛНА: КАБАНЧИКИ',
  victoryText: 'ВОЛНА ОТРАЖЕНА',
};
